module.exports = __webpack_public_path__ + "static/img/accommodation-view-tabs01.d3fbdac5.svg";